/* global nw */

import Phaser from 'phaser';
import GoldButton from 'ui/button';
import { COLORS, DEMO_MODE } from 'helpers/constants';
import SpriteButton from 'ui/spriteButton';
import { endSceneAndChildScenes } from 'helpers/sceneHelpers';

export const mainMenuControllerMenuOptions = {
  mute_bg: {
    button: null,
    directions: {
      up: 'main_menu',
      down: 'overworld',
      right: 'mute_ambient',
      left: 'mute_ambient'
    }
  },
  mute_ambient: {
    button: null,
    disabled: true,
    directions: {
      up: 'main_menu',
      down: 'overworld',
      right: 'mute_bg',
      left: 'mute_bg'
    }
  },
  overworld: {
    button: null,
    disabled: true,
    directions: {
      up: 'mute_bg',
      down: 'restart'
    }
  },
  restart: {
    button: null,
    disabled: true,
    directions: {
      up: 'overworld',
      down: 'main_menu'
    }
  },
  main_menu: {
    button: null,
    selected: true,
    directions: {
      up: 'restart',
      down: 'mute_bg'
    }
  }
};

export default class OptionsMainMenu extends Phaser.Scene {
  constructor(config = 'OptionsMainMenuScene') {
    super(config);
  }
  init(data) {
    this.data = data;
    this.scale.on('resize', this.resize);
    this.events.on('shutdown', () => {
      this.scale.off('resize', this.resize);
      this.keyShown = false;
    });
  }
  resize = (gameSize, baseSize, displaySize, previousWidth, previousHeight) => {
    const scale = this.game.defaultZoom;
    const { centerX, centerY } = this.cameras.main;
    this.menuBackdropRect = new Phaser.Geom.Rectangle(
      0,
      0,
      this.game.canvas.width,
      this.game.canvas.height
    );
    this.menuBackdrop.fillRectShape(this.menuBackdropRect);
    this.mainMenuTitle.setPosition(
      centerX - 5 * scale,
      this.cameras.main.centerY - 68 * scale
    );

    this.mainMenuBG.setPosition(centerX, centerY).setScale(scale);
    this.exitToMainMenu.resetPosition(centerX, centerY + 50 * scale);
    this.exitToDekstop &&
      this.exitToDekstop.resetPosition(centerX, centerY + 50 * scale);
    this.backOutButton.resetPosition(centerX, centerY);
    this.backOutButtonFreeplay.resetPosition(centerX, centerY);
    this.backOutButtonMultiplayer.resetPosition(centerX, centerY);
    this.exitToVersus.resetPosition(centerX, centerY);
    this.toggleMusic.resetPosition(centerX, centerY + 25 * scale);
    this.toggleAmbience.resetPosition(centerX, centerY - 25 * scale);
  };
  create() {
    const scale = this.game.defaultZoom;
    this.mainMenuVisible = false;
    this.menuBackdropRect = new Phaser.Geom.Rectangle(
      0,
      0,
      this.game.canvas.width,
      this.game.canvas.height
    );
    this.menuBackdrop = this.add.graphics();
    this.menuBackdrop.lineStyle(3, 0x5b87a1, 0);
    this.menuBackdrop.fillStyle(0x1f272c, 0);
    this.menuBackdrop.fillRectShape(this.menuBackdropRect);
    this.menuBackdrop.on('pointerdown', pointer => {
      if (this.mainMenuVisible) {
        this.setMainMenuVisible(false);
      }
    });
    let controllerIconPosition = { x: 86, y: 11 };
    if (this.data.isTitleScreenOptionsMenu) {
      this.optionsMenuButton = SpriteButton(this, {
        calcX: scene => 0,
        calcY: scene => 70 * scene.game.defaultZoom,
        sprite: 'ui_options_menu_button',
        action: pointer => {
          this.setMainMenuVisible(!this.mainMenuVisible);
        }
      }).setOrigin(0);
    } else {
      this.mainMenuButton = SpriteButton(this, {
        calcX: scene => 0,
        calcY: scene => 4 * scene.game.defaultZoom,
        sprite: 'ui_menu_button',
        action: pointer => {
          this.setMainMenuVisible(!this.mainMenuVisible);
        }
      }).setOrigin(0);
      this.menuButtonControllerIcon = this.add
        .sprite(
          controllerIconPosition.x * scale,
          controllerIconPosition.y * scale,
          'ui_controller_buttons',
          4
        )
        .setScale(scale)
        .setAlpha(this.game.controllerInput)
        .setDepth(15)
        .setOrigin(0);
    }

    this.mainMenuContainer = this.add.container();
    this.mainMenuContainer.setAlpha(0);

    this.mainMenuBG = this.add
      .nineslice(
        this.cameras.main.centerX,
        this.cameras.main.centerY,
        260,
        150,
        'ui_box', // image key
        6 // symmetrical corner size
      )
      .setScale(scale)
      .setInteractive()
      .setOrigin(0.5)
      .setDepth(20);

    this.mainMenuContainer.add(this.mainMenuBG);

    this.mainMenuTitle = this.add
      .text(
        this.cameras.main.centerX - 5 * scale,
        this.cameras.main.centerY - 68 * scale,
        `\n Main Menu`,
        {
          fontSize: `${scale * 8}px`,
          fontFamily: 'pixelMix',
          color: COLORS.LIGHT_BLUE,
          align: 'center'
        }
      )
      .setResolution(8)
      .setOrigin(0.5);

    this.mainMenuContainer.add(this.mainMenuTitle);

    this.exitToMainMenu = GoldButton(this, {
      text: 'Exit to Title Screen',
      x: this.cameras.main.centerX,
      y: this.cameras.main.centerY + 50 * scale,
      width: 120,
      height: 20,
      action: () => {
        if (this.isMultiplayerScene()) {
          this.confirmMultiplayerExit({
            text:
              'Are you sure you want to exit to the title screen?\n\nThis will disconnect you from the multiplayer match.',
            confirmLabel: 'Yes, exit to Title Screen.',
            action: () => {
              this.data.sceneRef.leaveMultiplayerGame?.('MenuScene');
            }
          });
          return;
        }
        this.mainMenuVisible = false;
        endSceneAndChildScenes(this.data.sceneRef, () => {
          this.scene.start('MenuScene');
        });
      }
    });

    this.exitToDesktop = GoldButton(this, {
      text: 'Exit to Desktop',
      x: this.cameras.main.centerX,
      y: this.cameras.main.centerY + 50 * scale,
      width: 120,
      height: 20,
      action: () => {
        if (nw && nw.App) {
          nw.App.quit();
        }
      }
    });

    this.backOutButton = GoldButton(this, {
      text: 'Return to Overworld',
      x: this.cameras.main.centerX,
      y: this.cameras.main.centerY,
      width: 120,
      height: 20,
      action: this.returnToOverworld
    });

    this.backOutButtonFreeplay = GoldButton(this, {
      text: 'Return to Freeplay',
      x: this.cameras.main.centerX,
      y: this.cameras.main.centerY,
      width: 120,
      height: 20,
      action: this.returnToFreeplay
    });

    this.backOutButtonMultiplayer = GoldButton(this, {
      text: 'Return to Lobby',
      x: this.cameras.main.centerX,
      y: this.cameras.main.centerY,
      width: 120,
      height: 20,
      action: this.returnToMultiplayerLobby
    });

    mainMenuControllerMenuOptions.overworld.button = this.data.sceneRef
      .freeplayHighscore
      ? this.backOutButtonFreeplay
      : this.backOutButton;

    this.restartLevelButton = GoldButton(this, {
      text: 'Restart Level',
      x: this.cameras.main.centerX,
      y: this.cameras.main.centerY + 25 * scale,
      width: 120,
      height: 20,
      action: () => {
        this.data.sceneRef.restartBattle();
        this.setMainMenuVisible(false);
      }
    });

    mainMenuControllerMenuOptions.restart.button = this.restartLevelButton;

    this.exitToVersus = GoldButton(this, {
      text: 'Exit to Freeplay Menu',
      x: this.cameras.main.centerX,
      y: this.cameras.main.centerY,
      width: 120,
      height: 20,
      action: () => {
        this.returnToFreeplay();
      }
    });

    let muteAmbTextLabel = 'Mute BG Ambience';
    if (!this.game.ambience || !this.game.ambience.volume) {
      muteAmbTextLabel = 'Unmute BG Ambience';
    }
    this.toggleAmbience = GoldButton(this, {
      text: muteAmbTextLabel,
      x: this.cameras.main.centerX + 62 * scale,
      y: this.cameras.main.centerY - 40 * scale,
      width: 120,
      height: 20,
      action: () => {
        if (this.game.ambience && this.game.ambience.volume) {
          this.toggleAmbience.setText('Unmute BG Ambience');
          this.game.soundManager.setVolumeOfType('ambience', 0);
        } else {
          this.toggleAmbience.setText('Mute BG Ambience');
          this.game.soundManager.setVolumeOfType('ambience', 0.8);
        }
      }
    }).setAlpha(this.game.ambience && this.game.ambience.volume ? 1 : 0);

    if (this.game.ambience && this.game.ambience.volume) {
      mainMenuControllerMenuOptions.mute_ambient.disabled = false;
    }

    mainMenuControllerMenuOptions.mute_ambient.button = this.toggleAmbience;

    let muteTextLabel = 'Mute BG Music';
    if (!this.game.bgMusic || !this.game.bgMusic.volume) {
      muteTextLabel = 'Unmute BG Music';
    }
    this.toggleMusic = GoldButton(this, {
      text: muteTextLabel,
      x: this.cameras.main.centerX - 62 * scale,
      y: this.cameras.main.centerY - 40 * scale,
      width: 120,
      height: 20,
      action: () => {
        if (this.game.bgMusic.volume) {
          this.toggleMusic.setText('Unmute BG Music');
          this.game.soundManager.setVolumeOfType('bgMusic', 0);
        } else {
          this.toggleMusic.setText('Mute BG Music');
          this.game.soundManager.setVolumeOfType('bgMusic', 0.2);
        }
      }
    });

    mainMenuControllerMenuOptions.mute_bg.button = this.toggleMusic;

    this.mainMenuContainer.add(this.toggleAmbience);
    this.mainMenuContainer.add(this.toggleMusic);
    this.mainMenuContainer.add(this.exitToMainMenu);
    this.mainMenuContainer.add(this.exitToDesktop);
    this.mainMenuContainer.add(this.exitToVersus);
    this.mainMenuContainer.add(this.backOutButton);
    this.mainMenuContainer.add(this.backOutButtonFreeplay);
    this.mainMenuContainer.add(this.backOutButtonMultiplayer);
    this.mainMenuContainer.add(this.restartLevelButton);

    if (DEMO_MODE && this.data.isTitleScreenOptionsMenu) {
      this.exitToMainMenu.setAlpha('0');
      mainMenuControllerMenuOptions.main_menu.button = this.exitToDesktop;
    } else {
      this.exitToDesktop.setAlpha('0');
      mainMenuControllerMenuOptions.main_menu.button = this.exitToMainMenu;
    }

    if (this.data.sceneRef.scene.key === 'GameScene') {
      this.backOutButton.setAlpha(0);
      this.backOutButtonFreeplay.setAlpha(0);
    }
    this.backOutButtonMultiplayer.setAlpha(0);
    this.exitToVersus.setAlpha(0);

    if (this.data.onReady) {
      const button = this.data.isTitleScreenOptionsMenu
        ? this.optionsMenuButton
        : this.mainMenuButton;
      this.data.onReady(button);
    }
  }
  returnToFreeplay = () => {
    endSceneAndChildScenes(this.data.sceneRef, () => {
      this.scene.start('FreeplayShowcase');
    });
  };
  isMultiplayerScene = () =>
    this.data?.sceneRef?.scene?.key === 'MultiplayerLevelScene';

  confirmMultiplayerExit = ({ text, confirmLabel, action }) => {
    const sceneRef = this.data.sceneRef;
    sceneRef.originalMenuOptions = sceneRef.currentControllerMenuOptions;
    sceneRef.originalSelectedOption = sceneRef.currentMenuSelection;
    sceneRef.disableInput = true;
    sceneRef.scene.launch('DialogueScene', {
      text,
      scene: sceneRef,
      options: [
        {
          label: confirmLabel,
          action: () => {
            sceneRef.scene.stop('DialogueScene');
            action();
          }
        },
        {
          label: 'No, stay in match.',
          action: () => {
            setTimeout(() => {
              sceneRef.currentControllerMenuOptions =
                sceneRef.originalMenuOptions;
              sceneRef.currentMenuSelection = sceneRef.originalSelectedOption;
              sceneRef.disableInput = false;
              sceneRef.scene.stop('DialogueScene');
            }, 0);
          }
        }
      ]
    });
  };

  returnToMultiplayerLobby = () => {
    this.confirmMultiplayerExit({
      text:
        'Are you sure you want to return to the multiplayer lobby?\n\nThis will disconnect you from the current match.',
      confirmLabel: 'Yes, return to Lobby.',
      action: () => {
        this.data.sceneRef.leaveMultiplayerGame?.('OnlineMenuScene');
      }
    });
  };

  returnToOverworld = (options = {}) => {
    // set up a local function to be called after confirmation dialogue
    const returnToOverworld = () => {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
      }
      this.data.sceneRef.scene.stop('DialogueScene');
      this.data.sceneRef.clearCurrentMenuOptions();
      const coords = this.data.sceneRef.levelData.backoutWorldCoords
        ? this.data.sceneRef.levelData.backoutWorldCoords
        : this.data.sceneRef.levelData.worldCoords;
      if (this.data.sceneRef.scene.key !== 'WorldScene') {
        endSceneAndChildScenes(this.data.sceneRef, () => {
          this.scene.start('WorldScene', {
            playerPosition: {
              x: coords.x,
              y: coords.y
            }
          });
        });
      } else {
        if (this.data.sceneRef.inBattleLevelData.onLevelExit) {
          this.data.sceneRef.inBattleLevelData.onLevelExit(
            this.data.sceneRef,
            () => {
              this.data.sceneRef.endBattleLevel(coords, true);
              this.setMainMenuVisible(false);
            }
          );
        } else {
          this.data.sceneRef.endBattleLevel(coords, true);
          this.setMainMenuVisible(false);
        }
      }
    };

    this.data.sceneRef.originalMenuOptions = this.data.sceneRef.currentControllerMenuOptions;
    this.data.sceneRef.originalSelectedOption = this.data.sceneRef.currentMenuSelection;
    this.data.sceneRef.scene.launch('DialogueScene', {
      text: `Are you sure you want to return to the overworld?\n\nYou will lose all progress in this level!`,
      scene: this.data.sceneRef,
      options: [
        {
          label: 'Yes, return to Overworld.',
          action: returnToOverworld
        },
        {
          label: 'No, stay here.',
          action: () => {
            setTimeout(() => {
              this.data.sceneRef.currentControllerMenuOptions = this.data.sceneRef.originalMenuOptions;
              this.data.sceneRef.currentMenuSelection = this.data.sceneRef.originalSelectedOption;
              this.data.sceneRef.disableInput = false;
              this.data.sceneRef.scene.stop('DialogueScene');
              if (options.fromGameOver) {
                this.data.sceneRef.showGameOverScreen();
              }
            }, 0);
          }
        }
      ]
    });
  };

  setMainMenuVisible(visible) {
    const sceneRef = this.data?.sceneRef;
    const sceneRefActive = !!sceneRef?.sys?.settings?.active;

    if (!sceneRefActive || !sceneRef?.resetMenuButtons) {
      this.mainMenuVisible = false;
      if (this.mainMenuContainer) {
        this.mainMenuContainer.setAlpha(0);
      }
      if (this.menuBackdrop) {
        this.menuBackdrop.disableInteractive();
      }
      return;
    }

    this.mainMenuVisible = visible;
    if (visible) {
      this.originalMenuOptions = sceneRef.currentControllerMenuOptions;
      this.originalSelectedOption = sceneRef.currentMenuSelection;
      sceneRef.currentControllerMenuOptions = mainMenuControllerMenuOptions;
      sceneRef.resetMenuButtons();
      sceneRef.highlightButtonByName('main_menu');
      this.mainMenuContainer.setAlpha(1);
      this.menuBackdrop.setInteractive(
        this.menuBackdropRect,
        Phaser.Geom.Rectangle.Contains
      );
      this.backOutButtonFreeplay.setAlpha(0);
      this.backOutButton.setAlpha(0);
      this.backOutButtonMultiplayer.setAlpha(0);
      this.exitToVersus.setAlpha(0);
      this.restartLevelButton.setAlpha(0);
      mainMenuControllerMenuOptions.overworld.disabled = true;
      mainMenuControllerMenuOptions.restart.disabled = true;
      const sceneKey = sceneRef.scene.key;
      if (sceneKey === 'MultiplayerLevelScene') {
        this.backOutButtonMultiplayer.setAlpha(1);
        mainMenuControllerMenuOptions.overworld.button = this.backOutButtonMultiplayer;
        mainMenuControllerMenuOptions.overworld.disabled = false;
      }
      if (sceneKey === 'WorldScene') {
        mainMenuControllerMenuOptions.overworld.button = sceneRef.freeplayHighscore
          ? this.backOutButtonFreeplay
          : this.backOutButton;
        if (sceneRef.battlingInWorld) {
          this.restartLevelButton.setAlpha(1);
          mainMenuControllerMenuOptions.restart.disabled = false;
          if (sceneRef.inBattleLevelData?.returnToOverworldBlocked !== true) {
            if (sceneRef.freeplayHighscore) {
              this.backOutButtonFreeplay.setAlpha(1);
            } else {
              this.backOutButton.setAlpha(1);
            }
            mainMenuControllerMenuOptions.overworld.disabled = false;
          } else {
            if (sceneRef.freeplayHighscore) {
              this.backOutButtonFreeplay.setAlpha(1);
              mainMenuControllerMenuOptions.overworld.disabled = false;
            }
          }
        }
      } else if (['CastleScene', 'StoryLevelScene'].includes(sceneKey)) {
        mainMenuControllerMenuOptions.overworld.button = sceneRef.freeplayHighscore
          ? this.backOutButtonFreeplay
          : this.backOutButton;
        if (sceneRef.battlingInStory) {
          this.restartLevelButton.setAlpha(1);
          mainMenuControllerMenuOptions.restart.disabled = false;
        }
        if (sceneRef.levelData?.returnToOverworldBlocked !== true) {
          if (sceneRef.freeplayHighscore) {
            this.backOutButtonFreeplay.setAlpha(1);
          } else {
            this.backOutButton.setAlpha(1);
          }
          mainMenuControllerMenuOptions.overworld.disabled = false;
        } else {
          if (sceneRef.freeplayHighscore) {
            this.backOutButtonFreeplay.setAlpha(1);
            mainMenuControllerMenuOptions.overworld.disabled = false;
          }
        }
      }
    } else {
      sceneRef.currentControllerMenuOptions = this.originalMenuOptions || null;
      sceneRef.currentMenuSelection = this.originalSelectedOption || null;
      this.mainMenuContainer.setAlpha(0);
      this.menuBackdrop.disableInteractive();
    }
  }
  update() {
    if (
      this.game.controllerInput &&
      this.menuButtonControllerIcon &&
      !this.menuButtonControllerIcon.alpha &&
      this.mainMenuButton &&
      this.mainMenuButton.alpha === 1
    ) {
      this.menuButtonControllerIcon.setAlpha(1);
    }
    if (
      !this.game.controllerInput &&
      this.menuButtonControllerIcon &&
      this.menuButtonControllerIcon.alpha
    ) {
      this.menuButtonControllerIcon.setAlpha(0);
    }
    if (this.mainMenuButton && this.mainMenuButton.alpha === 0) {
      this.menuButtonControllerIcon.setAlpha(0);
    }
  }
}
